const TOKEN_KEY = "auth0_access_token";
const API_NAMESPACE_KEY = "api_namespace";

export type ApiNamespace = "merchant" | "system";

export const tokenService = {
  getAccessToken(): string | null {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch (error) {
      // eslint-disable-next-line no-console -- DEV-only diagnostic; localStorage can throw in private mode.
      if (import.meta.env.DEV) console.error("Error getting access token from localStorage:", error);
      return null;
    }
  },

  setAccessToken(token: string): void {
    try {
      localStorage.setItem(TOKEN_KEY, token);
    } catch (error) {
      // eslint-disable-next-line no-console -- DEV-only diagnostic; localStorage can throw in private mode.
      if (import.meta.env.DEV) console.error("Error storing access token in localStorage:", error);
    }
  },

  removeAccessToken(): void {
    try {
      localStorage.removeItem(TOKEN_KEY);
    } catch (error) {
      // eslint-disable-next-line no-console -- DEV-only diagnostic; localStorage can throw in private mode.
      if (import.meta.env.DEV) console.error("Error removing access token from localStorage:", error);
    }
  },

  hasAccessToken(): boolean {
    return !!this.getAccessToken();
  },

  getApiNamespace(): ApiNamespace {
    try {
      const namespace = localStorage.getItem(API_NAMESPACE_KEY);
      return (namespace === "system" ? "system" : "merchant") as ApiNamespace;
    } catch (error) {
      // eslint-disable-next-line no-console -- DEV-only diagnostic; localStorage can throw in private mode.
      if (import.meta.env.DEV) console.error("Error getting API namespace from localStorage:", error);
      return "merchant";
    }
  },

  setApiNamespace(namespace: ApiNamespace): void {
    try {
      localStorage.setItem(API_NAMESPACE_KEY, namespace);
    } catch (error) {
      // eslint-disable-next-line no-console -- DEV-only diagnostic; localStorage can throw in private mode.
      if (import.meta.env.DEV) console.error("Error storing API namespace in localStorage:", error);
    }
  },

  removeApiNamespace(): void {
    try {
      localStorage.removeItem(API_NAMESPACE_KEY);
    } catch (error) {
      // eslint-disable-next-line no-console -- DEV-only diagnostic; localStorage can throw in private mode.
      if (import.meta.env.DEV) console.error("Error removing API namespace from localStorage:", error);
    }
  },
};
